// extracted by mini-css-extract-plugin
export default {"container":"Work_container__-RDqi"};